import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';
import AddAppointment from "../../QuickAppoinmnet/AddAppoinment";
import { set } from "date-fns";


const AppointmentCancellationReschedule = () => { 
  const emailId = useSelector((state) => state.userData?.userData?.EmailID);
  const { t, i18n } = useTranslation();
  const [appointments, setAppointments] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [appointmentToCancel, setAppointmentToCancel] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const {isChatVisible, toggleChat, showChat } = useChat();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [editingAppointment, setEditingAppointment] = useState(null);
  const contract = useSelector((state) => state.userData);
  const userInfo = useSelector((state) => state.userData);
  const email = useSelector((state)=>state.email.email);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const devicetype = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const token = localStorage.getItem("AccessToken");
  
        const params = {
          Email: emailId,
          DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        };
  setLoading(true);
        const response = await axios.post(
          Endpoints.fetchAppointments,
          { _Params: JSON.stringify(params) },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Connection": "close",
              "Accept": "*/*",
              "Authorization": `Bearer ${token}`,
            },
          }
        );
       console.log("API Response:", response.data);
        if (response.data && Array.isArray(response.data)) {
          // Filter out canceled appointments
          const validAppointments = response.data.filter(
            (appointment) => appointment.Status !== "Canceled" // Adjust based on your API's status field
          );
          setAppointments(validAppointments);
        } else {
          console.error("Unexpected response format:", response.data);
        }
      } catch (error) {
        console.error("Failed to fetch appointments:", error);
      } finally {
        setLoading(false);
      }
    };
  
    if (emailId) {
      fetchAppointments();
    }
  }, [emailId, refreshKey]);
  

  // const handleReschedule = (appointment) => {
  //   // navigate("/book-appointment", { state: { ...appointment, isRescheduling: true } });
  //   navigate("/book-appointment");
  // };

  const formatDateToCustomFormat = (date) => {
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(new Date(date)); // Ensure date is a Date object
  };
  
  const formatDateToDDMMYYYY = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  
  // Set SelectedDate in DD-MM-YYYY format
  const now = new Date(); // Replace with the selected date in your actual implementation
  const SelectedDate = formatDateToDDMMYYYY(now); // Formatted date as DD-MM-YYYY
  

  const handleReschedule = (appointment) => {
    if (appointment.ProviderName) {
      // Open the modal with existing data for rescheduling
      setEditingAppointment(appointment);
      setIsPopupOpen(true);
    } else {
      // Navigate to book-appointment page
      navigate("/book-appointment", { state: { ...appointment, isRescheduling: true } });
    }
  };
  
  
  
  
  const handleCancel = (appointment) => {
    // Show confirmation modal before canceling
    setAppointmentToCancel(appointment);
    setModalMessage("Are you sure you would like to cancel the appointment?");
    setShowModal(true);
  };
  
  const handleProviderSearch=(appointment)=>
  {
    const { ProviderName, Address, City, State, ZipCode } = appointment;

  // Combine into full address
  const fullAddress = `${ProviderName},${Address}, ${City}, ${State} ${ZipCode}`;

  // Encode it for URL
  const encodedAddress = encodeURIComponent(fullAddress);
  // Create the Google Maps URL
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  // Open in a new tab
  window.open(googleMapsUrl, '_blank');

    const cancelandbookappoinment="Y";
    const selectedProviderType="Reproductive Endocrinologists/Infertility";
    //navigate("/map-search", {state:{appointment,cancelandbookappoinment,selectedProviderType}})
  }

  const confirmCancellation = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("AccessToken");
      const isProviderAppointment = appointmentToCancel?.ProviderName; // Distinguish the API endpoint
  
      const params = isProviderAppointment
        ? {
          SelectedDate: appointmentToCancel.SelectedDate,
          State: appointmentToCancel.State,
          ProviderName: appointmentToCancel.ProviderName,
          Action: "Cancel",
          Contract: userInfo.userData.ContractIdentified,
          Address: appointmentToCancel.Address,
          EditedDate:"",
          SelectedTime: appointmentToCancel.Time,
          MemberID: appointmentToCancel.MemberID,
          ZipCode: appointmentToCancel.ZipCode,
          City: appointmentToCancel.City,
          EditedTime:"",
          DeviceType:devicetype,
          EmailID: email
          }
        : {
            Time: appointmentToCancel.Time,
            OffSet: appointmentToCancel.OffSet,
            TimeZoneName: appointmentToCancel.TimeZoneName,
            SlotType: appointmentToCancel.SlotType,
            Text: "Booked",
            SelectedDate: appointmentToCancel.SelectedDate,
            UserName: "MAPP",
            CalendarType: "All",
            Email: emailId,
            OffsetDiff: appointmentToCancel.OffsetDiff,
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
          };
  
      const endpoint = isProviderAppointment
        ? Endpoints.providerappointment
        : Endpoints.confirmCancellation;
  
      const response = await axios.post(
        endpoint,
        isProviderAppointment
          ? `_Params=${encodeURIComponent(JSON.stringify(params))}`
          : { _Params: JSON.stringify(params) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
  
      if (
        (isProviderAppointment && response.data?.Result === 2)
      ) {
        // Remove canceled appointment
        setAppointments((prevAppointments) =>
          prevAppointments.filter(
            (appt) =>
              appt.SelectedDate !== appointmentToCancel.SelectedDate ||
              appt.Time !== appointmentToCancel.Time
          )
        );
        setRefreshKey((prevKey) => prevKey + 1); // Trigger a refresh
       // alert(t("Appointment canceled successfully."));
      } else if(response.data?.Result === 1){
        setShowModal(true);
        setModalMessage(response.data?.Data);
      } else {
        console.error("Failed to cancel appointment:", response.data);
        alert(response.data?.Message || t("Failed to cancel appointment."));
      }
    } catch (error) {
      console.error("Error canceling appointment:", error);
    } finally {
      // Reset modal state
      setShowModal(false);
      setAppointmentToCancel(null);
      setLoading(false);
    }
  };
  

  const isAppointmentTimeNow = (appointmentTime, appointmentDate, appointmentTimeZone, appointmentOffsetDiff) => {
    // Combine the date and time into a single string, assuming the appointmentDate is in a proper format
    //const dateString = `${appointmentDate} ${appointmentTime} ${appointmentTimeZone} ${appointmentOffsetDiff}`;
    const dateString = `${appointmentDate} ${appointmentTime} ${appointmentOffsetDiff}`;
    
    // Try creating a new Date object and check for validity
    const appointmentDateTime = new Date(dateString);
  const currentTime = new Date();
    return currentTime >= appointmentDateTime;
};
  console.log(isAppointmentTimeNow)
  const handleJoinClick =(appointment)=>
  {
   console.log(appointment);
   const roomname =appointment.VideoRoomName
   navigate("/patientconsultation", { state: { roomname } })
  }
  const handleBackClick = () => {
    navigate("/home"); // Redirects to the home page
  };
  const handleAddAppointment = () => {
    setEditingAppointment(null); // Ensure form opens with no preloaded data
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setEditingAppointment(null);
  };
  const navigateToBookAppointment = () => {
    navigate("/book-appointment");
  };
  const providerAppointments = appointments.filter((appt) => appt.ProviderName);
  const consultAppointments = appointments.filter((appt) => !appt.ProviderName);
function formatSelectedDateToMMDDYYYY(dateStr) {
  // If already MM/DD/YYYY, return as is
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) return dateStr;
  // Expects "30-Sep-2025"
  if (!dateStr) return "";
  const months = {
    Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
    Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
  };
  const [day, mon, year] = dateStr.split("-");
  return `${months[mon]}/${day}/${year}`;
}
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }
 
    return (
      <>
       <div className="col-md-12">
        <div className="row">
          <div className="col-md-6 upcoming-provider-left-wrapper">
            <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
              <button className="win-back-btn" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i>{t('Back')}</span></button>
            
              <h2 className="page-heading">
  {isHighmarkPortal ? t('upcominghimarkConsults') : t('upcomingWINConsults')}
</h2>
            </div>
            {consultAppointments.length > 0 ? (
      <p>{t('rescheduletext')} 
        
      {isHighmarkPortal?t('conslthimarkmessage'):t('consltmessage')}</p>
    ) : (
      isHighmarkPortal ?<p>You don't currently have any Nurse Care Advocate consults planned. Schedule one now.</p>: <p>You don't currently have any WIN Nurse Care Advocate consults planned. Schedule one now.</p>
    )}
            <button
                className="win-btn-secondary-w-content mobile-view my-4 highmark-option-full-bg"
                onClick={navigateToBookAppointment}
              >
                {t("Book an Appointment")}
              </button>
            <div className="col-md-12">
              <div className="appointment-wrapper">
              {consultAppointments.length > 0 ? (
                  consultAppointments.map((appt, index) => (
                    <div className="appointment-details-wrapper" key={index}>
                      <div className="appointment-details">
                      {t('appointmentScheduled', {
                        slotType: appt.SlotType,
                        date: formatSelectedDateToMMDDYYYY(appt.SelectedDate),
                        time: appt.Time,
                        timeZone: appt.TimeZoneName
                      })}
                      </div>
                      <div className="appointment-details-btns-wrapper">
                        {isAppointmentTimeNow(
                          appt.Time,
                          appt.SelectedDate,
                          appt.TimeZoneName,
                          appt.OffsetDiff
                        ) ? (
                          <button className="win-btn-primary"  onClick={() => handleJoinClick(appt)}>{t('join')}</button>
                        ) : (
                          <>
                        <button className="win-btn-secondary highmark-option-no-border me-md-2" onClick={() => handleCancel(appt)}>{t('cancelAppointment')}</button>
                        <button className="win-btn-primary" onClick={() => handleReschedule(appt)}>{t('reschedule')}</button>
                        </>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <p>{t('')}</p>
                )}
               
              </div>
            </div>
          </div>
       

     
          <div className="col-md-6 upcoming-provider-appointment-wrapper highmark-option-background">
            
          {providerAppointments.length > 0 ? (
    <>
      <h2 className="page-heading highmark-optional-heading ms-0">{t('Upcoming Provider Appointments')}</h2>
      <p>{t('rescheduletextt')}</p>
      <h4 className="page-heading highmark-optional-heading ms-0">{t('providerheader')}</h4>
      <p>{t('providerdetails')}</p>
    </>
  ) : (
    <>
      <h4 className="page-heading highmark-optional-heading ms-0">{t('providerheader')}</h4>
      <p>{t('providerdetails')}</p>
    </>
  )}
              <button onClick={handleAddAppointment} className="win-btn-secondary-w-content mobile-view my-4">
                {t('Add Provider Appointment')}
              </button>

            <div className="appointment-wrapper">
              {providerAppointments.length > 0 ? (
                providerAppointments.map((appt, index) => (
                  <div className="appointment-details-wrapper" key={index}>
                    <div className="appointment-details">
                    {appt.ProviderName}
                    <br />
                {`${appt.Address} - ${formatSelectedDateToMMDDYYYY(appt.SelectedDate)} at ${appt.Time}`}
                    </div>
                    <div className="provider-details-btns-wrapper">
                      <button className="win-btn-secondary highmark-option-no-border mobile-view me-0 me-md-2 mb-2 mb-md-0" onClick={() => handleCancel(appt)}>
                        {t('cancelAppointment')}
                      </button>
                      <button className="win-btn-primary mobile-view  me-0 me-md-2 mb-2 mb-md-0" onClick={() => handleReschedule(appt)}>
                        {t('reschedule')}
                      </button>
                      <button className="win-btn-primary mobile-view" onClick={() => handleProviderSearch(appt)}>Show in Maps</button>
                    </div>
                  </div>
                ))
              ) : <p>{t('')}</p>}
            </div>

              
            {isPopupOpen && (
              <AddAppointment
                isOpen={isPopupOpen}
                onClose={handleClosePopup}
                existingData={editingAppointment}
                onRefresh={() => setRefreshKey((prevKey) => prevKey + 1)}
              />
            )}
          </div>
        </div>
      <ErrorModal 
        show={showModal} 
        message={modalMessage} 
        isCancellationSelected={true}  
        onClose={() => {
        setShowModal(false);
        setAppointmentToCancel(null); // Clear selected appointment when modal is closed
        }} 
        onOkay={confirmCancellation} 
      />
      </div>

        
      {/* {isChatVisible && <ChatBotWindow />} */}
      </>
    )
  };
  
  export default AppointmentCancellationReschedule; 
